import { asColor } from 'app/shared/elements/gauges/as-color';
import { GaugeColors } from 'app/shared/elements/gauges/gauge-colors';
import { GaugeColorSegment } from 'app/shared/elements/gauges/gauge-segments';
import { clamp } from 'app/shared/lib/noop';
import { bindingMode } from 'aurelia-framework';
import { bindable } from 'aurelia-typed-observable-plugin';

const DEFAULT_COLORS: GaugeColorSegment[] = [
    { threshold: 0.3, color: GaugeColors.Green },
    { threshold: 0.7, color: GaugeColors.Yellow },
    { threshold: 1.0, color: GaugeColors.Red }
];

export abstract class GaugeBase {

    @bindable.number({ name: 'value' })
    protected value: number = 0;

    @bindable.string({ name: 'label' })
    protected label: string = '';

    @bindable.string({ name: 'color' })
    protected color: string | null = null;  //Specific CSS background color

    @bindable.number({ name: 'min' })
    protected min: number = 0;  //The min range of input values,  Used for normalization

    @bindable.number({ name: 'max' })
    protected max: number = 100;  //The max range of input values.  Used for normalization

    @bindable.number({ name: 'precision' })
    protected precision: number = 2;

    protected normalize(value: number): number {
        return clamp((value - this.min) / (this.max - this.min), 0, 1);
    }

    protected asColor(value: number): string {
        return asColor(this.normalize(value), DEFAULT_COLORS);
    }

    protected precisionAsNumberFormat(precision: number) {
        return `!#0.${'#'.repeat(precision)}`;
    }
}
